
































































import { Component, Vue } from "vue-property-decorator";
import { Form as elForm } from "element-ui";
import { Md5 } from "ts-md5";
import { PostLogin, PostLogin2 } from "@/request/account";
@Component({})
export default class Login extends Vue {
  private ifShowSetect: any = false;
  private window: any = window;
  private projects: any = [
    {
      name: "saas",
      children: [
        {
          parent: "saas",
          name: "测试",
          title: "saas-test",
          value: "test",
          API_ROOT: "https://saas-test.i-tcm.cn/",
          needJiami: true,
        },
        {
          parent: "saas",
          name: "线上",
          title: "saas",
          value: "production",
          API_ROOT: "https://saas.i-tcm.cn/",
          needJiami: true,
        },
      ],
    },
    {
      name: "曙光",
      children: [
        {
          parent: "曙光",
          name: "测试",
          title: "shuguang",
          value: "test",
          API_ROOT: "https://shuguang.i-tcm.cn/",
          needJiami: true,
        },
        {
          parent: "曙光",
          name: "线上",
          title: "webservice",
          value: "webservice",
          API_ROOT: "https://webservice.sgyy.cn:8484/",
          needJiami: true,
        },
      ],
    },
    {
      name: "广东民族医",
      children: [
        {
          parent: "广东民族医",
          name: "测试",
          title: "minzuyi-test",
          value: "test",
          API_ROOT: "https://minzuyi-test.i-tcm.cn/",
          needJiami: true,
        },
        {
          parent: "广东民族医",
          name: "线上",
          title: "minzuyi",
          value: "production",
          API_ROOT: "https://minzuyi.i-tcm.cn/",
          needJiami: true,
        },
      ],
    },
    {
      name: "国际蒙医",
      children: [
        {
          parent: "国际蒙医",
          name: "测试",
          title: "gjmy-test",
          value: "test",
          API_ROOT: "https://gjmy-test.i-tcm.cn/",
          needJiami: true,
        },
      ],
    },
    {
      name: "宁波中医院",
      children: [
        {
          parent: "宁波中医院",
          name: "测试",
          title: "ningbo-test",
          value: "test",
          API_ROOT: "https://ningbo-test.i-tcm.cn/",
          needJiami: true,
        },
        {
          parent: "宁波中医院",
          name: "线上",
          title: "外网",
          value: "外网",
          API_ROOT: "https://szy.nbszyy.com.cn:28665/",
          needJiami: true,
        },
      ],
    },
    {
      name: "番茄心康",
      children: [
        {
          parent: "番茄心康",
          name: "测试",
          title: "fqxk-test",
          value: "test",
          API_ROOT: "https://fqxk-test.i-tcm.cn/",
        },
        {
          parent: "番茄心康",
          name: "线上",
          title: "fqxk",
          value: "production",
          API_ROOT: "https://fqxk.i-tcm.cn/",
        },
      ],
    },
    {
      name: "云博仕",
      children: [
        {
          parent: "云博仕",
          name: "测试",
          title: "ybs-test",
          value: "test",
          API_ROOT: "https://ybs-test.medkg.cn/",
        },
      ],
    },
  ];
  private currentPro: any = {};
  private info: any = {
    用户名: "",
    密码: "",
  };
  private rules: any = {
    用户名: [{ required: true, message: "用户名必须填写", trigger: "blur" }],
    密码: [{ required: true, message: "密码必须填写", trigger: "blur" }],
  };
  /**
   * @description 登录
   */
  private login(): void {
    console.log("登录");
    (this.$refs.loginForm as elForm).validate((isValid: boolean) => {
      const Base64 = require("js-base64").Base64;
      if (isValid) {
        if (this.currentPro.needJiami) {
          const params: any = {
            account: this.info["用户名"],
            密码: Md5.hashStr("qihuang" + this.info["密码"]),
            // 密码: Base64.encode(this.info["密码"]),
          };
          PostLogin(this, params)
            .then((res: any) => {
              const token = res.token;
              const user = res.user;
              this.$store.commit("updateToken", token);
              this.$store.commit("updateUser", user);
              this.$router.push("/template/create-tempalte");
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            })
            .catch((error: any) => {});
        } else {
          if (this.currentPro.parent == "番茄心康") {
            const params: any = {
              account: this.info["用户名"],
              密码: this.info["密码"],
            };
            PostLogin2(this, params)
              .then((res: any) => {
                const token = res.token;
                const user = res.user;
                this.$store.commit("updateToken", token);
                this.$store.commit("updateUser", user);
                this.$router.push("/template/create-tempalte");
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              })
              .catch((error: any) => {});
          }
        }
      }
    });
  }
  private selectPro(item: any) {
    this.currentPro = item;
    this.$store.commit("updateProData", item);
    window.API_ROOT = item.API_ROOT;
    this.$store.commit("updateAPIROOT", item.API_ROOT);
    this.ifShowSetect = false;
  }
  private mounted() {
    // this.ifShowSetect = true;
    const item: any = {
      parent: "广东民族医",
      name: "线上",
      title: "minzuyi",
      value: "production",
      API_ROOT: "https://minzuyi.i-tcm.cn/",
      needJiami: true,
    };
    this.currentPro = item;
    this.$store.commit("updateProData", item);
    window.API_ROOT = item.API_ROOT;
    this.$store.commit("updateAPIROOT", item.API_ROOT);
  }
}
